import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'

import { _DiscoverAreaCta } from './styles'


const DiscoverAreaCta = ({
  setDiscoveryAreaOpenState,
  areas,
  onCloseSearch,
  showDiscoverArea,
}) => {
  const handleCtaClick = () => {
    setDiscoveryAreaOpenState(true)
    onCloseSearch()
  }
  if(showDiscoverArea) {
    return (
      <_DiscoverAreaCta onClick={handleCtaClick}>
        Explore {areas.label} Neighbourhoods
        <SvgIcon name={'#icon-arrow-final'} width={9} height={9} />
      </_DiscoverAreaCta>
    )
  }
  return null
}

DiscoverAreaCta.propTypes = {
  setDiscoveryAreaOpenState: PropTypes.func,
  userCurrentArea: PropTypes.shape({}),
  areas: PropTypes.shape({
    label: PropTypes.string,
  }),
  onCloseSearch: PropTypes.func,
  showDiscoverArea: PropTypes.bool,
}

export default DiscoverAreaCta
